export default {
feedback: {
  title: "ข้อเสนอแนะ",
  placeholder: "ฝากข้อความ ({ contentLen }/1000 ตัวอักษร)",
  error: "นี่คือข้อความผิดพลาด",
  uploadLimit: "จำกัดการอัปโหลดรูปภาพและวิดีโอ",
  send: "ส่ง",
  tipTitle: "ช่วยเราปรับปรุงประสบการณ์ของคุณ",
  desc1: "คุณสามารถส่งคำถามใด ๆ ได้ และหากได้รับการยอมรับ คุณจะได้รับของขวัญพิเศษ",
  desc2: "หากไม่สะดวกผ่านเว็บไซต์ คุณสามารถส่งทางอีเมลได้"
}
};
